import { withI18n } from 'panda-i18n';
import locale from '@/locale';
import { CnEmployeeSelect as UICnEmploySelect } from './employee-select';
import './styles/index.scss';
const CnEmployeeSelect = withI18n(UICnEmploySelect, {
    locale,
    _noHoc: true,
});
export { CnEmployeeSelect };
